{
  "base": "Rapportering",
  "segment": {
    "budget": "Budsjett og revisorbekreftelse",
    "funds": "Tildelte midler",
    "administration": "Gjennomføring og administrasjon",
    "esa": "ESA-rapportering",
    "declaration": "Egenerklæring",
    "goals": "Måltall",
    "registration": "Registrering",
    "timeline": "Status",
    "confirmation": "Kvittering",
    "summary": "Oppsummering",
    "feedback": "Tilbakemelding",
    "approved": "Godkjente måltall",
    "achieved": "Måloppnåelse",
    "companies": "Bedriftsnivå",
    "operator": "Operatørnivå",
    "activities": "Aktiviteter",
    "edit": "Rediger",
    "deadlines": "Frister"
  },
  "title": {
    "index": "Rapportering",
    "budget": "Budsjett og revisorbekreftelse",
    "goals": "Måltall",
    "goalsYear": "Måltall {{year}}",
    "achieved": "Måloppnåelse",
    "achievedYear": "Måloppnåelse {{year}}",
    "funds": "Tildeling og bruk av midler",
    "fundsYear": "Tildelte midler {{year}}",
    "administrationYear": "Gjennomføring og administrasjon {{year}}",
    "declaration": "Egenerklæring",
    "declarationYear": "Egenerklæring {{year}}",
    "deadlines": "Frister Siva",
    "confirmation": "Innsendt",
    "feedback": "Oppsummering",
    "esa": "ESA-rapportering",
    "esaYear": "ESA-rapportering {{year}}"
  },
  "lead": {
    "funds": "Oversikt over gjennomføring og administrasjon og bruk av ESA-rapportering (artikkel 28)"
  },
  "goals": {
    "introSections": "Måltall for {{year}} består av følgende seksjoner:",
    "introQuestionCount": "Det er totalt {{questionCount}} spørsmål og alle må besvares. Vi anbefaler å legge inn en kommentar hvis det er nødvendig å begrunne tallet.",
    "introDeadline": "Endelig svarfrist er 1. desember {{year}}",
    "introShow": "Vis måltall {{year}}",
    "confirmationSubmittedAt": "Måltall {{year}} ble sendt inn {{date}}",
    "confirmationSupport": "Hvis du har tekniske spørsmål kan du sende epost til flerbedriftsportal@innovasjonnorge.no",
    "confirmationViewGoals": "Se måltall {{year}}",
    "closedForReporting": "Måltall kan ikke legges inn for {{year}} fordi rapportåret er stengt for innrapportering.",
    "noGoalsFound": "Fant ingen mål for {{year}}.",
    "lastSaved": "Sist lagret {{timestamp}}",
    "sections": "Seksjoner",
    "autoSaveNotice": "Skjemaet blir lagret underveis.",
    "categoryIntro": "Alle tall og prosenter gjelder for år {{year}} og er obligatoriske. Vi anbefaler å legge inn kommentarer for å forklare måltallene, spesielt hvis det er et stort avvik fra fjoråret.",
    "summaryHeading": "Oppsummering",
    "showDescription": "Vis beskrivelse",
    "commentOptional": "Kommentar (valgfritt)",
    "previousYearValue": "Måltall fra {{year}}: {{value}}",
    "editGoal": "Rediger måltall {{name}}",
    "sivaComment": "Kommentar fra Siva",
    "originalValue": "Opprinnelig måltall",
    "updateError": "Kunne ikke oppdatere måltall",
    "loadError": "Kunne ikke hente ut måltall",
    "submitError": "Kunne ikke sende inn måltall",
    "submitUpdatedError": "Kunne ikke sende inn oppdaterte måltall",
    "noFeedbackTitle": "Vi beklager, det har skjedd en feil.",
    "noFeedbackBody": "Det er ikke registrert at dere har fått tilbakemelding på noen måltall. Dere kan kun oppdatere måltall dere har fått tilbakemelding på. Send inn slik at at Siva kan legge inn tilbakemeldinger.",
    "status": {
      "saved": "Lagret",
      "savedBody": "Måltall {{year}} er lagret {{timestamp}}",
      "savedLink": "Rediger måltall {{year}}",
      "submitted": "Sendt til Siva",
      "submittedBody": "Måltall {{year}} ble sendt til Siva og måltallene kan ikke endres",
      "feedback": "Tilbakemelding fra Siva",
      "feedbackBody": "Etter gjennomgang av måltallene har Siva gitt tilbakemeldinger på måltall {{year}}",
      "feedbackLink": "Se tilbakemeldinger fra Siva",
      "approved": "Godkjent",
      "approvedBody": "Måltall {{year}} har blitt godkjent av Siva",
      "viewGoals": "Se måltall {{year}}"
    }
  },
  "achieved": {
    "total": "Total måloppnåelse",
    "downloadReport": "Last ned oversiktsrapport",
    "updateAllGoals": "Oppdater alle mål",
    "editAchievement": "Rediger måloppnåelse",
    "levels": "Nivå",
    "viewDetails": "Vis detaljer",
    "valueLabel": "Verdi",
    "value": "Verdi: {{value}}",
    "goalValue": "Måltall: {{value}}",
    "ofTotal": "av {{total}}",
    "progressLabel": "{{name}}: {{value}} av {{expected}}",
    "autoSaved": "Endringene er autolagret kl. {{time}}",
    "endEditing": "Avslutt redigering",
    "goalForYear": "Måltall {{year}}: {{value}}",
    "editedConfirmation": "Måloppnåelse er redigert.",
    "srlDescription": "Det skal angis hvilket SRL-nivå bedriften er på per 31.12 (eller da bedriften gikk ut av program i løpet av året). Klikk på oransje spørsmålstegn for å se beskrivelse av de ni trinnene i SRL-skalaen.",
    "euDescriptionScope": "Det skal registreres om bedriften bidrar til vesentlig eller potensiell vesentlig positiv effekt på ett eller flere av de 6 miljømålene i EU-taksonomien. Det skal også registreres om bedriften bidrar til vesentlig eller potensiell vesentlig skade på noen av de samme målene (mtp prinsippet om «Do no significant harm»). Dersom bedriften ikke bidrar til hverken vesentlige positive eller negative effekter, haker dere av for “Ingen”. Dersom dere er i tvil om bedriften bidrar til vesentlige positive eller negative effekter, krysser dere av for «ingen».",
    "euDescriptionHelp": "Klikk på oransje spørsmålstegn for å se beskrivelse av de seks miljømålene, samt hva som kreves for å bidra til (potensiell) vesentlig positiv eller negativ miljøeffekt.",
    "euDescriptionCalculation": "Måltallet er angitt som andel av bedriftene som har (potensielt) vesentlig positivt bidrag på minst ett av målene. Kriteriet om (potensiell) vesentlig skade har ikke påvirkning på beregning av måloppnåelse."
  },
  "funds": {
    "tableCaption": "Tildelte midler {{year}}",
    "article28": "Artikkel 28",
    "preIncubation": "Preinkubasjon",
    "otherPhases": "Øvrige faser",
    "administration": "Gjennomføring og administrasjon",
    "totalAllocated": "Sum tildelte midler {{year}}"
  },
  "deadline": {
    "finishAnnualReporting": {
      "title": "Ferdigstill årsrapportering",
      "description": "All rapportering for forutgående år må være ferdigstilt i Flerbedriftsportalen"
    },
    "uploadGoals": {
      "title": "Last opp måltall",
      "description": "Opplasting av måltall for inneværende år i Flerbedriftsportalen"
    },
    "regionalReporting": {
      "title": "Send inn regionalrapportering",
      "description": "Skjema for regionalrapportering skal fylles ut og oversendes til Innovasjon Norge"
    },
    "uploadAuditorConfirmation": {
      "title": "Last opp revisorbekreftelse",
      "description": "Opplasting av revisorbekreftelse på totale kostnader brukt på gjennomføring og administrasjon knyttet til programaktiviteten i fjor (ikke statsstøtte). Bruk mal fra Innovasjon Norge"
    },
    "ktuUpdate": {
      "title": "KTU-oppdatering: Legg inn nye opptak og exit",
      "description": "Oppdatere Flerbedriftsportalen med nye opptak og avsluttede bedrifter"
    },
    "reportArticle28FirstHalf": {
      "title": "Rapporter innovasjonsstøtte (art 28) første halvår",
      "description": "Rapportering av bruk av innovasjonsstøtte (artikkel 28) per første halvår"
    },
    "uploadBudget": {
      "title": "Last opp budsjett for kommende år",
      "description": "Opplasting av budsjett for gjennomføring og administrasjon for kommende år. Bruk mal fra Innovasjon Norge"
    },
    "registerActiveCompanies": {
      "title": "Siste frist for å legge inn alle aktive bedrifter for i år",
      "description": "Alle bedrifter som er/har vært aktive i løpet av året må være registrert i Flerbedriftsportalen"
    }
  },
  "invalidYear": "Ugyldig årstall",
  "selectYear": "Velg år"
}
